import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';

import { AuthService } from '../services/auth.service';
import { EnvService } from '../services/env.service';
import { CommonService } from '../services/common.service';

import * as $ from "jquery";

@Component({
	selector: 'app-main',
	templateUrl: './main.component.html',
	styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {


	frm : FormGroup;

	constructor(
		private http: HttpClient,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService
	) {
		this.frm = new FormGroup({
			saddr: new FormControl('', Validators.required),
			eaddr: new FormControl('', Validators.required),
			carton: new FormControl({
				value: '오토바이',
				disabled: false
			}),
			cartype: new FormControl({
				value : '',
				disabled: true
			})
		});
	}

	ngOnInit() {
	}

	changeCar() {
		var val = this.frm.get('carton').value;

		if( val == "오토바이" || val == "다마스" || val == "라보" )
		{
			this.frm.get('cartype').disable();
			this.frm.get('cartype').setValue("");
		}
		else
		{
			this.frm.get('cartype').enable();
		}
	}
}
